import {createUseStyles} from 'react-jss'

export default createUseStyles({
    header: {
      width: '100%',        
      height: 'auto',
      minHeight: 60,
      backgroundColor: '#004f9f',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      zIndex: 99,
      position: 'fixed',
      boxShadow: '0 3px 6px rgba(0,0,0,0.4)'
    },
    headerIcon: {
      color: 'white',
      position: "relative",
      height: 40,
      width: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 25,
      cursor: 'pointer',
      borderRadius: 50,
      transition: '0.1s',
      
    },
    userInfo: {
      display: 'flex',
      alignItems: 'center',
      margin: '0 5px 0 20px',
      cursor: 'pointer',
      position:'relative',
      height: '100%'
    },
    userImage: {
      height: 40,
      width: 40,
      border: '1px solid white',
      borderRadius: 50,
      marginRight: 10,
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      overflow:'hidden',
      '& img': {
        width: '150%',
        height: '150%',
        backgroundColor: 'white'
      },
      '& svg': {
        color:'white',
        fontSize: 30
      } 
    },
    logo: {
      height: '100%',
      padding: '5px',
      marginLeft: 10,
      cursor: 'pointer',
      '& img': {
        height: '100%'
      }
    },
    userName: {
      color: 'white'
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: 60
    },
    headerRight: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: 60

    },
    headerMiddle: {
      display: 'flex',
      justifyContent: 'flex-end',
      margin: '0 20px',
      alignItems: 'center',
      height: '60px',
      width:'100%',
      position:'relative',
      '& a': {
        display: 'flex',
        alignItems:'center',
        color: 'white',
        margin: '0 10px',
        padding: '0 20px',
        cursor: 'pointer',
        height:'100%',
        position: 'relative'
      },

      
    },
    '@media screen and (max-width: 500px)': {
      userName: {
        display: 'none'
      },
      userImage: {
        margin: 0
      },
      header: {
        padding: '0 10px'
      }
    },
    '@media screen and (max-width: 900px)': {
      headerMiddle: {
        width: '100%',
        order: 3,
        justifyContent: 'center'
      },
      headerLeft: {
        order: 1,
      },
      headerRight: {
        order: 2,
      },
      header: {
        flexWrap: 'wrap',
      }
    },
    selection: {
      position: 'absolute',
      height: 3,
      width: '100%',
      backgroundColor:'white',
      bottom: 0,
      left: 0
    },
    
    nav: {
      paddingTop: 20,
      position: 'fixed',
      top: 0,
      left: 0,
      boxShadow: '0 3px 6px rgba(0,0,0,0.4)',
      width: 280,
      height: '100vh',
      backgroundColor: '#004f9f',
      zIndex: 101,
      transition: '0.3s',
      display: 'flex',
      flexDirection: 'column',
      '& a': {
        padding: '12px ',
        color: 'white',
        transition: '0.3s',
        textDecoration: 'none',
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
        marginRight: 20,
        margin: '5px 0',
        '& svg': {
          marginRight: 30,
          fontSize: 20
        },
        '&:hover, &.selected': {
          borderLeft: '3px solid white',
          backgroundColor: '#003163',
        }
      }
    },

    filter: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.16)',
      zIndex: 100
    },

    'container': {
      backgroundColor: "#121212"
    },

    uppercase: {
      textTransform: 'uppercase'
    }
})